var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$UIPrivilege('dispatching', 'voip_phone'))?_c('div',{staticClass:"call-button-holder"},[_c('img',{class:_vm.callButtonClass,attrs:{"src":"/traveller-ui/static/traveller/img/call.png","alt":"call"},on:{"click":_vm.call}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }